export default "__VITE_ASSET__ByuR4p2p__"